import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import CharCounter from "./CharCounter";

export const NUMERO_INFORMADO_MAX_LENGTH = 10;

export function montarNumeroProcessoPreview(prefixo, numeroInformado, ano) {
  const prefixoLimpo = (prefixo || "").trim();
  const numeroLimpo = (numeroInformado || "").trim();
  if (!prefixoLimpo || !numeroLimpo) return "";
  return `${prefixoLimpo}${numeroLimpo}/${ano}`;
}

export function ehNumeroInformadoValido(numeroInformado) {
  return /^[0-9]{1,10}$/.test(String(numeroInformado || "").trim());
}

/**
 * Campo composto: {prefixo}{numero}/{ano}
 * @param {{
 *   prefixo: string,
 *   value: string,
 *   onChange: (value: string) => void,
 *   ano?: number,
 *   disabled?: boolean,
 *   error?: boolean,
 *   helperText?: string,
 *   label?: string,
 * }} props
 */
function NumeroProcessoField({
  prefixo,
  value,
  onChange,
  ano = new Date().getFullYear(),
  disabled = false,
  error = false,
  helperText,
  label = "Número do Processo",
}) {
  const preview = montarNumeroProcessoPreview(prefixo, value, ano);

  const handleChange = (event) => {
    const apenasDigitos = event.target.value.replace(/\D/g, "").slice(0, NUMERO_INFORMADO_MAX_LENGTH);
    onChange(apenasDigitos);
  };

  return (
    <Box>
      <TextField
        label={label}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        error={error}
        helperText={helperText}
        required={!disabled}
        fullWidth
        inputProps={{
          inputMode: "numeric",
          maxLength: NUMERO_INFORMADO_MAX_LENGTH,
          "aria-label": label,
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                {prefixo || "—"}
              </Typography>
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <Typography variant="body2" color="text.secondary" sx={{ mr: 1, fontWeight: 600 }}>
                /{ano}
              </Typography>
              <CharCounter value={value} maxLength={NUMERO_INFORMADO_MAX_LENGTH} />
            </InputAdornment>
          ),
        }}
      />
      {preview ? (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: "block" }}>
          Prévia: {preview}
        </Typography>
      ) : null}
    </Box>
  );
}

export default NumeroProcessoField;
